export function useClinicAnalytics() {
  const getSessionId = (): string => {
    if (import.meta.server) return ''
    const KEY = 'vet_session'
    let id = sessionStorage.getItem(KEY)
    if (!id) {
      id = `${Date.now()}-${Math.random().toString(36).slice(2)}`
      sessionStorage.setItem(KEY, id)
    }
    return id
  }

  const tracked = new Set<string>()

  const trackEvent = async (clinicId: string, eventType: string) => {
    if (import.meta.server) return

    const key = `${clinicId}-${eventType}`
    if (tracked.has(key)) return
    tracked.add(key)

    $fetch('/api/clinics/track', {
      method: 'POST',
      body: {
        clinicId,
        eventType,
        sessionId: getSessionId(),
        referrer: document.referrer && !document.referrer.startsWith(window.location.origin)
          ? document.referrer
          : null,
      },
    }).catch(() => {
      // Silently fail - analytics should not break user experience
    })
  }

  return {
    trackPageView: (clinicId: string) => trackEvent(clinicId, 'PAGE_VIEW'),
    trackPhoneClick: (clinicId: string) => trackEvent(clinicId, 'PHONE_CLICK'),
    trackWebsiteClick: (clinicId: string) => trackEvent(clinicId, 'WEBSITE_CLICK'),
    trackDirectionsClick: (clinicId: string) => trackEvent(clinicId, 'DIRECTIONS_CLICK'),
  }
}
